module.exports = __webpack_public_path__ + "static/media/no-notes.64db1c3e.png";